export default "__VITE_ASSET__CTjYj$OA__"